import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./styles/main.scss";

import Register from "./pages/register";
import Login from "./pages/login";
import ForgetPassword from "./pages/forget-password";
import ChangePassword from "./pages/change-password";
import Home from "./pages/Home";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import Unauthorized from "./pages/unauthorized";
import ConnectToFacebook from "./components/FacebookComponent/ConnectToFacebook";
import ConnectToInstagram from "./components/InstagramComponent/ConnectToInstagram";
import ConnectToWhatsApp from "./components/WhatsAppComponent/ConnectToWhatsApp";
import CheckValidty from "./PrivateRoute/CheckValid";

import Logout from "./pages/logout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminStores from "./pages/admin/AdminStores";
import AdminStore from "./pages/admin/AdminStore";
import AdminMail from "./pages/admin/AdminMail";
import AdminRoute from "./PrivateRoute/AdminRoute";
import NotFound from "./pages/not-found";
import GoogleComplete from "./pages/google-complete";
import GoogleCallback from "./pages/google-callback";
import { withTranslation } from 'react-i18next';
import { readSession, refreshSessionIfNeeded } from "./helpers/global";
import { rememberTrackingIdentity } from "./helpers/tracking";

function App(props) {
  const { i18n  } = props;

  // Keeps the portal session alive for as long as the user keeps using it, so
  // it never expires out from under an open store admin.
  useEffect(() => {
    refreshSessionIfNeeded();
    // Sessions from before the identity existed pick it up on this visit.
    rememberTrackingIdentity(readSession());
  }, []);

  if(i18n.language === 'ar') {
    document.documentElement.lang = "ar";
    document.documentElement.dir = "rtl";
  } else {
    document.documentElement.lang = "en";
    document.documentElement.dir = "ltr";
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/register"
          element={
            <CheckValidty>
              <Register />
            </CheckValidty>
          }
        />
        <Route
          path="/login"
          element={
            <CheckValidty>
              <Login />
            </CheckValidty>
          }
        />
        <Route
            path="/logout"
            element={
                <Logout />
            }
        />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        {/* "Continue with Google": existing account / new store details. */}
        <Route path="/google/callback" element={<GoogleCallback />} />
        <Route path="/google/complete" element={<GoogleComplete />} />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ChangePassword />
            </PrivateRoute>
          }
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminStores />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/stores/:id"
          element={
            <AdminRoute>
              <AdminStore />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/mail"
          element={
            <AdminRoute>
              <AdminMail />
            </AdminRoute>
          }
        />
        <Route
          path="/channels/facebook"
          element={
            <PrivateRoute>
              <ConnectToFacebook />
            </PrivateRoute>
          }
        />
        <Route
          path="/channels/instagram"
          element={
            <PrivateRoute>
              <ConnectToInstagram />
            </PrivateRoute>
          }
        />
        <Route
          path="/channels/whatsapp"
          element={
            <PrivateRoute>
              <ConnectToWhatsApp />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default withTranslation()(App);
